<template>
  <div class="service">
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="search"
    ></sirui-search>
    <div class="main-content">
      <sirui-table
        ref="serviceTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        ></vxe-table-column>
      </sirui-table>
    </div>
    <div v-if="serviceDialogVisible">
      <ServiceDialog
        :isEdit="isEdit"
        :serviceDialogVisible="serviceDialogVisible"
        :productList="productList"
        :editServiceCode="editServiceCode"
        :railwayServiceList="railwayServiceList"
        :subwayList="subwayList"
        :waterwayList="waterwayServiceList"
        :id="selectId"
        :isApproval="isApproval"
        @closeDialog="closeDialog"
        ref="serviceDialog"
      />
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import ServiceDialog from './components/serviceDialog';
  import API from '@/api/intermodality/service';
  export default {
    name: 'service',
    components: {
      SiruiSearch,
      SiruiTable,
      ServiceDialog,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      searchColumns() {
        return [
          {
            name: '服务编号',
            prop: 'code',
            type: 'input',
          },
          {
            name: '产品',
            prop: 'productId',
            type: 'select',
            options: this.productList,
            changeMethod: this.handleProduct,
          },
          {
            name: '服务',
            prop: 'name',
            type: 'input',
          },
          // {
          //   name: '创建人',
          //   prop: 'createBy',
          //   type: 'searchTableSpec',
          //   searchType: 'personnel',
          //   isMultiple: true,
          // },
          {
            name: '创建人',
            prop: 'createBy',
            type: 'input',
          },
          {
            name: '审核状态',
            prop: 'status',
            type: 'select',
            options: this.statusOptions,
          },
        ];
      },
    },
    data() {
      return {
        statusOptions: [
          { label: '草稿', value: '0' },
          // { label: '审批中', value: '1' },
          { label: '审批通过', value: '2' },
          { label: '审批驳回', value: '3' },
        ],
        query: {
          code: null,
          productId: null,
          name: null,
          createBy: null,
          status: null,
        },
        menuButtonList: [],
        columnList: [],
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            type: 'index',
            title: '序号',
            width: '50',
            fixed: 'left',
          },
          {
            field: 'gmtCreate',
            title: '创建时间',
            visible: true,
          },
          {
            field: 'code',
            title: '服务编号',
            visible: true,
          },
          {
            field: 'productName',
            title: '产品',
            visible: true,
          },
          {
            field: 'expenseDTOS',
            title: '费目',
            visible: true,
          },
          {
            field: 'name',
            title: '服务',
            visible: true,
          },
          {
            field: 'personName',
            title: '创建人',
            visible: true,
          },
          {
            field: 'serviceStatusName',
            title: '审批状态',
            visible: true,
          },
        ],
        load: false,
        tableData: [],
        multipleSelection: [],
        defaultMenuList: [
          { label: '新增', attributes: { buttonUrl: 'add' }, type: '0' },
          { label: '编辑', attributes: { buttonUrl: 'edit' }, type: '0' },
          { label: '审批通过', attributes: { buttonUrl: 'approval' }, type: '0' },
          { label: '审批驳回', attributes: { buttonUrl: 'reject' }, type: '0' },
        ],
        isEdit: false,
        serviceDialogVisible: false,
        productList: [],
        editServiceCode: '',
        waterwayServiceList: [
          {
            label: '水路运输',
            value: '8',
          },
          {
            label: '装卸服务',
            value: '9',
          },
          {
            label: '水路咨询服务',
            value: '10',
          },
        ],
        railwayServiceList: [
          {
            label: '铁路运输代理服务',
            value: '6',
          },
          {
            label: '铁路装卸服务',
            value: '7',
          },
        ],
        subwayList: [
          {
            label: '普通公路运输',
            value: '0',
          },
          {
            label: '集卡运输服务',
            value: '1',
          },
          {
            label: '公路装卸服务',
            value: '2',
          },
          {
            label: '咨询服务',
            value: '3',
          },
          {
            label: '仓储服务',
            value: '4',
          },
          {
            label: '监管服务',
            value: '5',
          },
        ],
        serviceList: [],
        selectId: '',
        isApproval: false,
      };
    },
    mounted() {
      this.$nextTick(() => {
        this.getData();
        this.getButtonList();
        this.getProductList();
      });
    },
    created() {
      if (this.$route.query.from === 'todo') {
        // 审批过来的
        const query = this.$route.query;
        this.editServiceCode = query.businessNo || '';
        this.isEdit = true;
        this.isApproval = true;
        this.serviceDialogVisible = true;
      }
    },
    methods: {
      // 获取产品列表
      getProductList() {
        this.$axios
          .post(API.DATA_DICT, {
            dictType: 'service_product',
            tenantCode: this.userInfo.tenantCode,
          })
          .then((res) => {
            if (res.data.code === 0) {
              let data = res.data.data || [];
              data.forEach((item) => {
                this.productList.push({
                  label: item.label,
                  value: item.value,
                });
              });
            }
          });
      },
      handleProduct(val) {
        if (val == 1) {
          // 铁路运输
          this.serviceList = this.railwayServiceList;
        } else if (val == 2) {
          this.serviceList = this.waterwayServiceList;
        } else {
          // 公路运输
          this.serviceList = this.subwayList;
        }
      },
      // 重置
      resetBtnClick() {
        this.$refs.serviceTable.setPageNum(1);
        this.$refs.serviceTable.setPageSize(10);
        this.$refs.serviceTable.clearCheckboxReserve();
        this.getData();
      },
      // 搜索
      search() {
        this.$refs.serviceTable.setPageNum(1);
        this.$refs.serviceTable.clearCheckboxReserve();
        this.getData();
      },
      //搜索下拉按钮最终抛出
      // searchChooseClick(btnUrl, arr) {
      //   console.log(btnUrl, arr, '22222333');
      // },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e.length > 0 ? e : this.defaultMenuList;
          this.getColumnInfo();
        });
      },
      // 获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          console.log(res, ' 111');
          this.columnList = this.columnListDefault;
        });
      },
      chooseClick(type) {
        console.log(type, 'type');
        if (type === 'add') {
          console.log('新增弹框');
          this.isEdit = false;
          this.serviceDialogVisible = true;
        } else if (type === 'edit') {
          console.log('编辑弹框');
          this.handleEdit();
        } else if (type === 'reject') {
          // 驳回
          this.handleReject('1');
        } else if (type === 'approval') {
          // 通过
          this.handleReject('0');
        }
      },
      handleEdit() {
        const selectedLength = this.multipleSelection.length || 0;
        if (selectedLength === 0) {
          this.$message({
            showClose: true,
            message: '您还未选择任何数据',
            type: 'error',
          });
        } else if (selectedLength > 1) {
          this.$message({
            showClose: true,
            message: '您只能选择一条数据进行修改',
            type: 'error',
          });
        } else {
          // if (this.multipleSelection[0].status === 2) {
          //   return this.$message({
          //     showClose: true,
          //     message: '只能编辑草稿或审批驳回状态的数据',
          //     type: 'error',
          //   });
          // }
          this.editServiceCode = this.multipleSelection[0].code || '';
          this.selectId = this.multipleSelection[0].id || '';
          this.isEdit = true;
          this.serviceDialogVisible = true;
        }
      },
      handleReject(val) {
        // 1是驳回 0是通过
        if (this.resolveSelected('more')) {
          if (this.multipleSelection.length > 1) {
            this.$message({
              showClose: true,
              message: '只能选择一条数据',
              type: 'error',
            });
          } else {
            let code = '';
            this.multipleSelection.forEach((item) => {
              if (item.status == 0) {
                code = item.code;
              }
            });
            if (!code) {
              this.$message({
                showClose: true,
                message: '您只能选择状态草稿的数据',
                type: 'error',
              });
            } else {
              let params = {
                code: code,
                isApproval: val,
                adminFlag: this.userInfo.adminFlag,
              };
              this.$axios.post(API.APPROVAL, params).then((res) => {
                if (res.data.code === 0) {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'success',
                  });
                  this.getData();
                  this.multipleSelection = [];
                  this.$refs.serviceTable.clearCheckboxReserve();
                }
              });
            }
          }
        }
      },
      // 是否选择数据
      resolveSelected(type) {
        if (this.multipleSelection.length === 0) {
          this.$message({
            showClose: true,
            message: '您还未选择任何数据',
            type: 'error',
          });
          return false;
        } else if (this.multipleSelection.length > 1) {
          if (type && type === 'more') return true;
          this.$message({
            showClose: true,
            message: '请选择一条数据操作',
            type: 'error',
          });
          return false;
        }
        return true;
      },
      handleSizeChange() {
        this.getData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getData();
      },
      getData() {
        const { pageNum, pageSize } = this.$refs.serviceTable.page;
        const params = { ...this.query, pageNum, pageSize };
        const { adminFlag } = this.userInfo;
        // if ((params.createBy || []).length > 0) {
        //   params.createBy = params.createBy[0].id || '';
        // }
        params.adminFlag = adminFlag;
        this.$axios.post(API.SERVICE_LIST, params).then((res) => {
          if (res.data.code === 0) {
            this.tableData = res.data.data.list || [];
            this.tableData.forEach((item) => {
              item.serviceStatusName = this.trans(item.status);
            });
            this.$refs.serviceTable.setPageTotal(this.tableData.length);
          }
        });
      },
      trans(code) {
        let serviceStatusName = '';
        if (code === 0) {
          serviceStatusName = '草稿';
        } else if (code === 1) {
          serviceStatusName = '审批中';
        } else if (code === 2) {
          serviceStatusName = '审批通过';
        } else {
          serviceStatusName = '审批驳回';
        }
        return serviceStatusName;
      },
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      closeDialog(val) {
        this.serviceDialogVisible = val;
        this.editServiceCode = '';
        this.isEdit = false;
        this.getData();
      },
    },
  };
</script>

<style scoped></style>
